import { render } from "./CustomerInfo.vue?vue&type=template&id=07939b86"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=07939b86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__